import React, { useEffect, useMemo, useState } from 'react'
import "./headerStyle.scss"
import Checkbox from "../checkbox/Checkbox";
import Checkbox1 from "../checkbox/Checkbox1";
import TimerControl from './TimerControl'
import { AuthState } from '../../../context/AuthProvider'
import ResultHeader from './ResultHeader'
import Buttons from './Buttons'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux';
import { SET_SERIES_TYPE, SelectSeriesType, SelectSeriesTypeDisableFlag } from "../../../redux/2d-slice/seriesSlice2d";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../../../context/SocketProvider";

import { Select1dGameID, Select1dLastSaleAmount, Select1dLastTicketId } from '../../../redux/1d-slice/gameInfo1dSlice.js';

import Marquee from "react-fast-marquee";
import SubHeader from './SubHeader';
function Header() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { socket } = SocketState()
  // let { userDetail } = AuthState()
  // let lastSaleAmount = useSelector(Select1dLastSaleAmount)
  // let lastTicketId = useSelector(Select1dLastTicketId)
  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)
  // let game_id = useSelector(Select1dGameID)
  const [gameType, setGameType] = React.useState('1d');

  const [timer, setTimer] = useState(null)
  const handleGameTypeChange = (selectedGameType) => {
    setGameType(selectedGameType);
    localStorage.setItem("gameRoute", selectedGameType)
    // Example: Navigation
    if (selectedGameType === '1d') {
      socket.emit('req', {
        en: "LOTTARY_CLOSE_GAME",
        data: {}
      });
      navigate('/1d');
    } else {
      navigate('/2d');
    }
  };
  useEffect(() => {
    let timeInterval = setInterval(() => {
      setTimer(moment().format('hh:mm:ss A'))
    }, 1000);

    return () => {
      clearInterval(timeInterval)
    }
  }, [])

  return (
    <>
      {/* <div className="headerContainerannoucements" >
        <Marquee>
          <p className="text-white text-[12px]">{annoucements}</p>
        </Marquee>
      </div> */}
      <tr colSpan="2" align="left">
        <ResultHeader />
      </tr>
      <tr colSpan="2" style={{ backgroundColor: '#eee8b4' }} align="left">
        <Buttons/>
      </tr>
      {/* <tr colSpan="2">
        <SubHeader/>
      </tr> */}
      
    </>
  )
}

export default Header